module.exports = __webpack_public_path__ + "static/2bb1e7445c6e6529aa3a5d9b86098d2c2f7fe654726220bc911f230c96f40c0a-32c3a6106c5ed6292690db66d453b913.jpeg";